// import React, { useEffect, useState } from 'react';
// import tenderWiseLogo from '../../Assets/images/Frame 39059 1.png';
// import { IoPrint } from 'react-icons/io5';
// import apiClient from '../../Api/apiClient';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';

// const SingleInvoiceView = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [invoiceData, setInvoiceData] = useState([]);
//   const [premiumUser, setPremiumuser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const { id } = useParams();

//   useEffect(() => {
//     const fetchInvoiceData = async () => {
//       try {
//         const response = await apiClient.get(`/user/payment/statement?order_id=${id}`);
//         if (response.data?.verificationResponse) {
//           setInvoiceData(response.data.verificationResponse);
//         } else {
//           setInvoiceData([]);
//         }
//         if (response.data?.userDetails) {
//           setPremiumuser(response.data?.userDetails || '');
//         } else {
//           setPremiumuser(0);
//         }
//       } catch (err) {
//         setError('Failed to fetch invoice data');
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchInvoiceData();
//   }, [id]);

//   const handleRedirect = () => {
//     navigate('/billstatus');
//   };
//   const handlePrint = () => {
//     window.print();
//   };

//   return (
//     <div className="md:p-10 p-4 min-h-screen mt-28 2xl:mt-32 py-10">
//       <div className="flex justify-between items-center container my-2 border-b-2 pb-2 max-w-4xl mx-auto">
//         <h1 className="text-center font-semibold text-lg mb-2">Invoice</h1>
//         <div onClick={handlePrint} className="cursor-pointer relative group">
//           <IoPrint size={25} />
//         </div>
//       </div>
//       <div className="mt-4">
//         {invoiceData.length > 0 ? (
//           <div className="max-w-4xl mx-auto bg-white shadow-md rounded-md p-6">
//             <div className="flex flex-col md:flex-row justify-between items-center mb-6">
//               <img src={tenderWiseLogo} alt="Logo" className="rounded-lg h-auto 2xl:w-48 md:w-44 w-36" />
//               <div className="text-right md:text-sm text-xs">
//                 {invoiceData[0]?.date_time && <p className="text-gray-600">Date: {invoiceData[0].date_time}</p>}
//                 {invoiceData[0]?.invoice_no && <p className="text-gray-600">Invoice No: {invoiceData[0].invoice_no}</p>}
//               </div>
//             </div>
//             <h3 className="text-lg font-semibold text-gray-800 mb-2 border-b-2">Invoice To:</h3>
//             <div className="mb-6 flex flex-col md:flex-row justify-between md:text-sm text-xs">
//               <div>
//                 {invoiceData[0]?.name && <p className="text-gray-600">Name: {invoiceData[0].name}</p>}
//                 {invoiceData[0]?.phone_no && <p className="text-gray-600">Phone: {invoiceData[0].phone_no}</p>}
//                 {invoiceData[0]?.email && <p className="text-gray-600">Email: {invoiceData[0].email}</p>}
//                 {invoiceData[0]?.address && <p className="text-gray-600">Address: {invoiceData[0].address}</p>}
//               </div>
//               <div>
//                 {invoiceData[0]?.card_number && <p className="text-gray-600">Account Number: {invoiceData[0].card_number}</p>}
//                 {invoiceData[0]?.bank_trx_id && <p className="text-gray-600">Transaction Id: {invoiceData[0].bank_trx_id}</p>}
//                 {invoiceData[0]?.order_id && <p className="text-gray-600">Order Id: {invoiceData[0].order_id}</p>}
//                 {invoiceData[0]?.bank_status && <p className="text-gray-600">Transaction Status: {invoiceData[0].bank_status}</p>}
//               </div>
//             </div>
//             <div className="text-center mt-2 flex flex-col md:flex-row justify-between">
//               {invoiceData[0]?.date_time && <p className="md:text-base lg:text-sm text-xs md:mb-0 mb-2 text-gray-600 font-medium">Invoice was created on {invoiceData[0].date_time}</p>}
//               <button onClick={handleRedirect} className="bg-DefaultColor hover:bg-DefaultHoverColor px-2 py-1 rounded-md text-white text-xs">
//                 Close View
//               </button>
//             </div>
//           </div>
//         ) : (
//           <p className="text-blue-500 text-center">Loading...</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SingleInvoiceView;





// import React, { useEffect, useState } from 'react';
// import tenderWiseLogo from '../../Assets/images/Frame 39059 1.png';
// import { IoPrint } from 'react-icons/io5';
// import apiClient from '../../Api/apiClient';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';

// const SingleInvoiceView = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [invoiceData, setInvoiceData] = useState([]);
//   const [premiumUser, setPremiumUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [message, setMessage] = useState("");

//   const { id } = useParams();



//   useEffect(() => {
//     const fetchInvoiceData = async () => {
//       try {
//         const response = await apiClient.get(`/user/payment/statement?order_id=${id}`);
//         if (response.data?.verificationResponse) {
//           setInvoiceData(response.data.verificationResponse);
//         } else {
//           setInvoiceData([]);
//         }
//         if (response.data?.userDetails) {
//           setPremiumUser(response.data?.userDetails || '');
//         } else {
//           setPremiumUser(0);
//         }
//       } catch (err) {
//         setError('Failed to fetch invoice data');
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchInvoiceData();
//   }, [id]);

//   const handleRedirect = () => {
//     navigate('/billstatus');
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   if (loading) {
//     return <p className="text-blue-500 text-center">Loading...</p>;
//   }

//   if (error) {
//     return <p className="text-red-500 text-center">{error}</p>;
//   }

//   return (
//     <div className="md:p-10 p-4 min-h-screen mt-28 2xl:mt-32 py-10">
//       <div className="flex justify-between items-center container my-2 border-b-2 pb-2 max-w-4xl mx-auto">
//         <h1 className="text-center font-semibold text-lg mb-2">Invoice</h1>

//         <div className="flex gap-4 items-center">
//           <div onClick={handlePrint} className="cursor-pointer relative group">
//             <IoPrint size={25} />
//           </div>
//           <button
//             onClick={handleRedirect}
//             className="bg-DefaultColor hover:bg-DefaultHoverColor px-2 py-1 rounded-md text-white text-xs"
//           >
//             Close View
//           </button>
//         </div>
//       </div>

//       <div className="mt-4">
//         {invoiceData.length > 0 ? (
//           <div className="max-w-4xl mx-auto bg-white shadow-md rounded-md p-6">
//             <div className="flex flex-col md:flex-row justify-between items-center mb-6">
//               <img
//                 src={tenderWiseLogo}
//                 alt="Logo"
//                 className="rounded-lg h-auto 2xl:w-48 md:w-44 w-36"
//               />
//               <div className="text-right md:text-sm text-xs">
//                 {invoiceData[0]?.date_time && (
//                   <p className="text-gray-600">Date: {invoiceData[0].date_time}</p>
//                 )}
//                 {invoiceData[0]?.invoice_no && (
//                   <p className="text-gray-600">Invoice No: {invoiceData[0].invoice_no}</p>
//                 )}
//               </div>
//             </div>

//             <h3 className="text-lg font-semibold text-gray-800 mb-2 border-b-2">Invoice To:</h3>
//             <div className="mb-6 flex flex-col md:flex-row justify-between md:text-sm text-xs">
//               <div>
//                 {invoiceData[0]?.name && <p className="text-gray-600">Name: {invoiceData[0].name}</p>}
//                 {invoiceData[0]?.phone_no && <p className="text-gray-600">Phone: {invoiceData[0].phone_no}</p>}
//                 {invoiceData[0]?.email && <p className="text-gray-600">Email: {invoiceData[0].email}</p>}
//                 {invoiceData[0]?.address && <p className="text-gray-600">Address: {invoiceData[0].address}</p>}
//               </div>
//               <div>
//                 {invoiceData[0]?.card_number && (
//                   <p className="text-gray-600">Account Number: {invoiceData[0].card_number}</p>
//                 )}
//                 {invoiceData[0]?.bank_trx_id && (
//                   <p className="text-gray-600">Transaction Id: {invoiceData[0].bank_trx_id}</p>
//                 )}
//                 {invoiceData[0]?.order_id && (
//                   <p className="text-gray-600">Order Id: {invoiceData[0].order_id}</p>
//                 )}
//                 {invoiceData[0]?.bank_status && (
//                   <p className="text-gray-600">Transaction Status: {invoiceData[0].bank_status}</p>
//                 )}
//               </div>
//             </div>

//             <div className="text-center mt-2 flex flex-col md:flex-row justify-between">
//               {invoiceData[0]?.date_time && (
//                 <p className="md:text-base lg:text-sm text-xs md:mb-0 mb-2 text-gray-600 font-medium">
//                   Invoice was created on {invoiceData[0].date_time}
//                 </p>
//               )}

//             </div>
//           </div>
//         ) : (
//           <p className="text-blue-500 text-center">Loading...</p>
//         )}


//         {/* Payment Summary */}
//         <div className="max-w-3xl mx-auto bg-white shadow-md rounded-md p-6 mt-6">
//           <h3 className="text-lg font-semibold text-gray-800 pb-1 mb-1">
//             Payment Summary:
//           </h3>
//           <div className="overflow-x-auto">
//             <table className="w-full border-collapse border border-gray-300 text-sm">
//               <thead className="bg-gray-200">
//                 <tr>
//                   <th className="border border-gray-300 px-4 py-2 text-left">
//                     Bank Status
//                   </th>
//                   <th className="border border-gray-300 px-4 py-2 text-center">
//                     Payable Amount
//                   </th>
//                   <th className="border border-gray-300 px-4 py-2 text-center">
//                     Received Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {invoiceData.map((payment, index) => (
//                   <tr key={index}>
//                     <td className="border border-gray-300 px-4 py-2">
//                       {payment.method || 'N/A'}
//                     </td>
//                     <td className="border border-gray-300 px-4 py-2 text-center">
//                       {/* {payment.payable_amount || '0.00'} */}
//                       {Number(payment.payable_amount || 0).toFixed(2)}
//                     </td>
//                     <td className="border border-gray-300 px-4 py-2 text-center">
//                       {/* {payment.sp_message === 'cancelled' ||
//                           payment.sp_message === 'Failed'
//                             ? '0.00'
//                             : payment.recived_amount || '0.00'} */}
//                       {Number(
//                         payment.sp_message === 'cancelled' ||
//                           payment.sp_message === 'Failed'
//                           ? 0
//                           : payment.recived_amount || 0
//                       ).toFixed(2)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//               {/* Total Section */}
//               {invoiceData.map((discount, index) => (
//                 <tfoot>
//                   <tr>
//                     <td
//                       className="px-4 py-2 text-right font-medium"
//                       colSpan="2"
//                     >
//                       Sub Total:
//                     </td>
//                     {/* <td className="px-4 py-2 text-center">{discount.amount}</td>
//                          */}
//                     <td className="px-4 py-2 text-center  text-gray-800">
//                       {/* {discount.sp_message === 'cancelled' ||
//                           discount.sp_message === 'initiated' ||
//                           discount.sp_message === 'Failed'
//                             ? '0.00'
//                             : discount.amount || '0.00'} */}
//                       {Number(
//                         discount.sp_message === 'cancelled' ||
//                           discount.sp_message === 'initiated' ||
//                           discount.sp_message === 'Failed'
//                           ? 0
//                           : discount.amount || 0
//                       ).toFixed(2)}
//                     </td>
//                   </tr>

//                   <tr>
//                     <td
//                       className="px-4 py-2 text-right font-medium"
//                       colSpan="2"
//                     >
//                       Discount Percentage:
//                     </td>
//                     <td className="px-4 py-2 text-center">
//                       {discount.disc_percent}%
//                     </td>
//                   </tr>
//                   <tr>
//                     <td
//                       className="px-4 py-2 text-right font-medium"
//                       colSpan="2"
//                     >
//                       Discount Amount:
//                     </td>
//                     <td className="px-4 py-2 text-center">
//                       {/* {discount.discount_amount} */}
//                       {Number(discount.discount_amount || 0).toFixed(2)}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td
//                       className="px-4 py-2 text-right  text-gray-800"
//                       colSpan="2"
//                     >
//                       Grand Total:
//                     </td>
//                     <td className="px-4 py-2 text-center text-gray-800">
//                       {/* {discount.sp_message === 'cancelled' ||
//                           discount.sp_message === 'Failed'
//                             ? '0.00'
//                             : discount.recived_amount || '0.00'} */}
//                       {discount.sp_message === 'cancelled' ||
//                         discount.sp_message === 'Failed'
//                         ? '0.00'
//                         : Number(discount.recived_amount || 0).toFixed(2)}
//                     </td>
//                   </tr>
//                 </tfoot>
//               ))}
//             </table>
//           </div>
//         </div>

//         {invoiceData[0]?.method === 'CARD' && (
//           <div className="mb-6">
//             <h3 className="text-lg font-semibold text-gray-800 pb-1 mb-1">
//               Payment Summary:
//             </h3>

//             {/* Table */}
//             <div className="overflow-x-auto">
//               <table className="w-full border-collapse border border-gray-300 text-sm">
//                 {/* Separator Line with "Card Section" */}

//                 {/* Card Payment Table */}
//                 <thead className="bg-gray-200">
//                   <tr>
//                     <th className="border border-gray-300 px-4 py-2 text-left">
//                       Card Holder Name
//                     </th>
//                     <th className="border border-gray-300 px-4 py-2 text-left">
//                       USD amount
//                     </th>
//                     <th className="border border-gray-300 px-4 py-2 text-left">
//                       USD Rate
//                     </th>
//                     <th className="border border-gray-300 px-4 py-2 text-center">
//                       Payable Amount
//                     </th>
//                     <th className="border border-gray-300 px-4 py-2 text-center">
//                       Received Amount
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {invoiceData.map((payment, index) => (
//                     <tr key={index}>
//                       <td className="border border-gray-300 px-4 py-2">
//                         {payment.card_holder_name || 'N/A'}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2 text-center">
//                         {payment.usd_amt || '0.00'}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2 text-center">
//                         {payment.usd_rate || '0.00'}
//                       </td>
//                       <td className="border border-gray-300 px-4 py-2 text-center">
//                         {payment.sp_message === 'cancelled' ||
//                           payment.sp_message === 'initiated' ||
//                           payment.sp_message === 'Failed'
//                           ? '0.00'
//                           : payment.recived_amount || '0.00'}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>

//                 {/* Total Section */}
//                 {invoiceData.map((discount, index) => (
//                   <tfoot>
//                     <tr>
//                       <td
//                         className="px-4 py-2 text-right font-medium"
//                         colSpan="2"
//                       >
//                         Sub Total:
//                       </td>
//                       <td className="px-4 py-2 text-center  text-gray-800">
//                         {discount.sp_message === 'cancelled' ||
//                           discount.sp_message === 'Failed'
//                           ? '0.00'
//                           : discount.amount || '0.00'}
//                       </td>
//                     </tr>

//                     <tr>
//                       <td
//                         className="px-4 py-2 text-right font-medium"
//                         colSpan="2"
//                       >
//                         Discount Percentage:
//                       </td>
//                       <td className="px-4 py-2 text-center">
//                         {discount.disc_percent}%
//                       </td>
//                     </tr>
//                     <tr>
//                       <td
//                         className="px-4 py-2 text-right font-medium"
//                         colSpan="2"
//                       >
//                         Discount Amount:
//                       </td>
//                       <td className="px-4 py-2 text-center">
//                         {discount.discount_amount}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td
//                         className="px-4 py-2 text-right  text-gray-800"
//                         colSpan="2"
//                       >
//                         Grand Total:
//                       </td>
//                       <td className="px-4 py-2 text-center text-gray-800">
//                         {discount.sp_message === 'cancelled' ||
//                           discount.sp_message === 'Failed'
//                           ? '0.00'
//                           : discount.recived_amount || '0.00'}
//                       </td>
//                     </tr>
//                   </tfoot>
//                 ))}
//               </table>
//             </div>
//           </div>
//         )}

//         {/* Footer Section */}
//         <div className="mt-6 text-center">
//           <h3 className="text-lg font-semibold text-gray-800 mb-2 border-b pb-1">
//             Thank You
//           </h3>
//           <div className="text-center mt-2">
//             <p className="md:text-base lg:text-lg text-sm text-gray-600 font-medium">
//               Invoice was created on {invoiceData[0]?.date_time || 'N/A'}
//             </p>
//           </div>
//         </div>


//       </div>
//     </div>
//   );
// };


import React, { useEffect, useState } from 'react';
import tenderWiseLogo from '../../Assets/images/Frame 39059 1.png';
import { IoPrint } from 'react-icons/io5';
import apiClient from '../../Api/apiClient';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { format } from "date-fns";

const SingleInvoiceView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [invoiceData, setInvoiceData] = useState([]);
  const [premiumUser, setPremiumUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");

  const { id } = useParams();



  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        const response = await apiClient.get(`/user/payment/statement?order_id=${id}`);
        if (response.data?.verificationResponse) {
          setInvoiceData(response.data.verificationResponse);
        } else {
          setInvoiceData([]);
        }
        if (response.data?.userDetails) {
          setPremiumUser(response.data?.userDetails || '');
        } else {
          setPremiumUser(0);
        }
      } catch (err) {
        setError('Failed to fetch invoice data');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoiceData();
  }, [id]);

  const handleRedirect = () => {
    navigate('/billstatus');
  };

  const handlePrint = () => {
    window.print();
  };


  return (
    <div className="md:p-10 p-4 min-h-screen mt-28 2xl:mt-32 py-10">
      {loading && <div className="text-center mt-10">Loading...</div>}
      {error && <div className="text-center mt-10">{error}</div>}

      {!loading && !error && (
        <>
          <div className="flex justify-between items-center container my-2 border-b-2 pb-2 max-w-4xl mx-auto">
            <h1 className="text-center font-semibold text-lg mb-2">Invoice</h1>
            <div className="flex gap-4 items-center">
              <div onClick={handlePrint} className="cursor-pointer relative group">
                <IoPrint size={25} />
              </div>
              <button
                onClick={handleRedirect}
                className="bg-DefaultColor hover:bg-DefaultHoverColor px-2 py-1 rounded-md text-white text-xs"
              >
                Close View
              </button>
            </div>
          </div>

          <div className="mt-4">
            {invoiceData.length > 0 ? (
              <div className="max-w-4xl mx-auto bg-white shadow-md rounded-md p-6">
                <div className="flex flex-col md:flex-row justify-between items-center mb-6">
                  <img
                    src={tenderWiseLogo}
                    alt="Logo"
                    className="rounded-lg h-auto 2xl:w-48 md:w-44 w-36"
                  />
                  <div className="text-right md:text-sm text-xs">
                    {/* {invoiceData[0]?.date_time && (
                      <p className="text-gray-600">Date: {invoiceData[0].date_time}</p>
                    )} */}
                    {invoiceData[0]?.date_time && (
                      <p className="text-gray-600">
                        Date: {format(new Date(invoiceData[0].date_time), "dd-MMM-yyyy")}
                      </p>
                    )}

                    {invoiceData[0]?.invoice_no && (
                      <p className="text-gray-600">Invoice No: {invoiceData[0].invoice_no}</p>
                    )}
                  </div>
                </div>

                <h3 className="text-lg font-semibold text-gray-800 mb-2 border-b-2">Invoice To:</h3>
                <div className="mb-6 flex flex-col md:flex-row justify-between md:text-sm text-xs">
                  <div>
                    {invoiceData[0]?.name && <p className="text-gray-600">Name: {invoiceData[0].name}</p>}
                    {invoiceData[0]?.phone_no && <p className="text-gray-600">Phone: {invoiceData[0].phone_no}</p>}
                    {invoiceData[0]?.email && <p className="text-gray-600">Email: {invoiceData[0].email}</p>}
                    {invoiceData[0]?.address && <p className="text-gray-600">Address: {invoiceData[0].address}</p>}
                  </div>
                  <div>
                    {invoiceData[0]?.card_number && (
                      <p className="text-gray-600">Account Number: {invoiceData[0].card_number}</p>
                    )}
                    {invoiceData[0]?.bank_trx_id && (
                      <p className="text-gray-600">Transaction Id: {invoiceData[0].bank_trx_id}</p>
                    )}
                    {invoiceData[0]?.order_id && (
                      <p className="text-gray-600">Order Id: {invoiceData[0].order_id}</p>
                    )}
                    {invoiceData[0]?.bank_status && (
                      <p className="text-gray-600">Transaction Status: {invoiceData[0].bank_status}</p>
                    )}
                  </div>
                </div>

              </div>
            ) : (
              <p className="text-blue-500 text-center">Loading...</p>
            )}

            {/* Payment Summary */}
            <div className="max-w-3xl mx-auto bg-white shadow-md rounded-md p-6 mt-6">
              <h3 className="text-lg font-semibold text-gray-800 pb-1 mb-1">
                Payment Summary:
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300 text-sm">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="border border-gray-300 px-4 py-2 text-left">
                        Bank Status
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-center">
                        Payable Amount
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-center">
                        Received Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceData.map((payment, index) => (
                      <tr key={index}>
                        <td className="border border-gray-300 px-4 py-2">
                          {payment.method || 'N/A'}
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                         {Number(payment.payable_amount || 0).toFixed(2)} BDT
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          {Number(
                            payment.sp_message === 'cancelled' ||
                              payment.sp_message === 'Failed'
                              ? 0
                              : payment.recived_amount || 0
                          ).toFixed(2)} BDT
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  {/* Total Section */}
                  <tfoot>
                    {invoiceData.map((discount, index) => (
                      <tr key={index}>
                        <td className="px-4 py-2 text-right font-medium" colSpan="2">
                          Sub Total:
                        </td>
                        <td className="px-4 py-2 text-center text-gray-800">
                          {Number(
                            discount.sp_message === 'cancelled' ||
                              discount.sp_message === 'initiated' ||
                              discount.sp_message === 'Failed'
                              ? 0
                              : discount.amount || 0
                          ).toFixed(2)} BDT
                        </td>
                      </tr>
                    ))}
                    {invoiceData.map((discount, index) => (
                      <tr key={index}>
                        <td className="px-4 py-2 text-right font-medium" colSpan="2">
                          Discount Percentage:
                        </td>
                        <td className="px-4 py-2 text-center">
                          {discount.disc_percent}% 
                        </td>
                      </tr>
                    ))}
                    {invoiceData.map((discount, index) => (
                      <tr key={index}>
                        <td className="px-4 py-2 text-right font-medium" colSpan="2">
                          Discount Amount:
                        </td>
                        <td className="px-4 py-2 text-center">
                          {Number(discount.discount_amount || 0).toFixed(2)} BDT
                        </td>
                      </tr>
                    ))}
                    {invoiceData.map((discount, index) => (
                      <tr key={index}>
                        <td className="px-4 py-2 text-right text-gray-800" colSpan="2">
                          Grand Total:
                        </td>
                        <td className="px-4 py-2 text-center text-gray-800">
                          {discount.sp_message === 'cancelled' ||
                            discount.sp_message === 'Failed'
                            ? '0.00'
                            : Number(discount.recived_amount || 0).toFixed(2)} BDT
                        </td>
                      </tr>
                    ))}
                  </tfoot>
                </table>
              </div>
            </div>

            {invoiceData[0]?.method === 'CARD' && (
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-800 pb-1 mb-1">
                  Payment Summary:
                </h3>

                {/* Table */}
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse border border-gray-300 text-sm">
                    {/* Separator Line with "Card Section" */}

                    {/* Card Payment Table */}
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="border border-gray-300 px-4 py-2 text-left">
                          Card Holder Name
                        </th>
                        <th className="border border-gray-300 px-4 py-2 text-left">
                          USD amount
                        </th>
                        <th className="border border-gray-300 px-4 py-2 text-left">
                          USD Rate
                        </th>
                        <th className="border border-gray-300 px-4 py-2 text-center">
                          Payable Amount
                        </th>
                        <th className="border border-gray-300 px-4 py-2 text-center">
                          Received Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceData.map((payment, index) => (
                        <tr key={index}>
                          <td className="border border-gray-300 px-4 py-2">
                            {payment.card_holder_name || 'N/A'}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {payment.usd_amt || '0.00'}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {payment.usd_rate || '0.00'}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {payment.sp_message === 'cancelled' ||
                              payment.sp_message === 'initiated' ||
                              payment.sp_message === 'Failed'
                              ? '0.00'
                              : payment.recived_amount || '0.00'}
                          </td>
                        </tr>
                      ))}
                    </tbody>

                    {/* Total Section */}
                    <tfoot>
                      {invoiceData.map((discount, index) => (
                        <tr key={index}>
                          <td className="px-4 py-2 text-right font-medium" colSpan="2">
                            Sub Total:
                          </td>
                          <td className="px-4 py-2 text-center text-gray-800">
                            {discount.sp_message === 'cancelled' ||
                              discount.sp_message === 'Failed'
                              ? '0.00'
                              : discount.amount || '0.00'}
                          </td>
                        </tr>
                      ))}
                      {invoiceData.map((discount, index) => (
                        <tr key={index}>
                          <td className="px-4 py-2 text-right font-medium" colSpan="2">
                            Discount Percentage:
                          </td>
                          <td className="px-4 py-2 text-center">
                            {discount.disc_percent}%
                          </td>
                        </tr>
                      ))}
                      {invoiceData.map((discount, index) => (
                        <tr key={index}>
                          <td className="px-4 py-2 text-right font-medium" colSpan="2">
                            Discount Amount:
                          </td>
                          <td className="px-4 py-2 text-center">
                            {discount.discount_amount}
                          </td>
                        </tr>
                      ))}
                      {invoiceData.map((discount, index) => (
                        <tr key={index}>
                          <td className="px-4 py-2 text-right text-gray-800" colSpan="2">
                            Grand Total:
                          </td>
                          <td className="px-4 py-2 text-center text-gray-800">
                            {discount.sp_message === 'cancelled' ||
                              discount.sp_message === 'Failed'
                              ? '0.00'
                              : discount.recived_amount || '0.00'}
                          </td>
                        </tr>
                      ))}
                    </tfoot>
                  </table>
                </div>
              </div>
            )}

            {/* Footer Section */}
            <div className="mt-6 text-center">
              <h3 className="text-lg font-semibold text-gray-800 mb-2 border-b pb-1">
                Thank You
              </h3>
              <div className="text-center mt-2">
                {/* <p className="md:text-base lg:text-lg text-sm text-gray-600 font-medium">
                  Invoice was created on {invoiceData[0]?.date_time || 'N/A'}
                </p> */}
                <p className="md:text-base lg:text-lg text-sm text-gray-600 font-medium">
                   Invoice was created on {invoiceData[0]?.date_time 
                      ? format(new Date(invoiceData[0].date_time), "dd-MMM-yyyy") 
                      : "N/A"}
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SingleInvoiceView;





























